module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "forgot-password--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendFormRequest()
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.email !== '' || _vm.emailFocus,
      'has-error': _vm.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.email),
      expression: "formInfo.email"
    }],
    class: [{
      'border-1-20': _vm.formInfo.email !== '' || _vm.emailFocus
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email",
      "placeholder": "Type in your e-mail address..."
    },
    domProps: {
      "value": (_vm.formInfo.email)
    },
    on: {
      "focus": function($event) {
        _vm.emailFocus = true
      },
      "blur": function($event) {
        _vm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send me reset link")])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account several times? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "tcc-form-message",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.formStatus.submitting) ? _c('div', {
    staticClass: "visually-hidden"
  }, [_vm._v("\n            Submitting\n          ")]) : [(_vm.formStatus.shown) ? [(_vm.formStatus.title !== '') ? _c('h2', [(_vm.formStatus.success) ? [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-check",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })])] : [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })])], _vm._v("\n                " + _vm._s(_vm.formStatus.title) + "\n              ")], 2) : _vm._e(), _vm._v(" "), (_vm.formStatus.body !== '') ? _c('p', [_vm._v("\n                " + _vm._s(_vm.formStatus.body) + "\n              ")]) : _vm._e()] : (_vm.formStatus.submitted && this.errors.items && this.errors.items.length) ? [_c('h2', [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n                Please fill in the required information\n              ")]), _vm._v(" "), _c('p', [_vm._v("Please fill in all the mandatory fields - they are marked with an asterisk.")])] : _vm._e()]], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title color-1-100"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Forgot password?\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description color-2-77"
  }, [_vm._v("\n          Please enter the email address associated with your Clear Assured account."), _c('br'), _vm._v("\n          We will send you a reset password link and instructions on how to change it.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6fc6c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/ForgotPassword.vue
// module id = 1007
// module chunks = 0